// extracted by mini-css-extract-plugin
export default {"root":"TranslatePromptButton_root__-5f-E"};